'use strict';
function handleResponsiveLayout() {
    var breakpointTablet = 768;
    var breakpointLaptop = 1440;
    // элементы
    var featureItems = document.querySelectorAll('.features-highlight__item');
    var itemsToModify = Array.from(featureItems).slice(1, 4);
    var wirelessSpeakerMobile = document.querySelector('.wireless-speaker-mobile');
    var wirelessSpeakerTablet = document.querySelector('.wireless-speaker-tablet');
    var topBarSpecs = document.querySelectorAll('.top-bar__spec');
    var menuButton = document.querySelector('.menu__button');
    var designedForFutureMobile = document.querySelector('.designed-for-future-mobile');
    var designedForFutureTablet = document.querySelector('.designed-for-future-tablet');
    var lunaEyeMobile = document.querySelector('.luna-eye-mobile');
    var lunaEyeTablet = document.querySelector('.luna-eye-tablet');
    var headerNav = document.querySelector('.features-highlight__nav');
    var featuresMobile = document.querySelector('.features-mobile');
    var featuresTablet = document.querySelector('.features-tablet');
    var featuresLaptop = document.querySelector('.features-laptop');
    var footerLogo = document.querySelector('.footer__logo');
    var footerArrow = document.querySelector('.footer__arrow');
    var width = window.innerWidth;
    // MOBILE
    if (width < breakpointTablet) {
        wirelessSpeakerMobile.classList.remove('hidden');
        wirelessSpeakerTablet.classList.add('hidden');
        menuButton.classList.remove('hidden');
        designedForFutureMobile.classList.remove('hidden');
        designedForFutureTablet.classList.add('hidden');
        lunaEyeMobile.classList.remove('hidden');
        lunaEyeTablet.classList.add('hidden');
        featuresMobile.classList.remove('hidden');
        featuresTablet.classList.add('hidden');
        featuresLaptop.classList.add('hidden');
        footerLogo.classList.add('hidden');
        footerArrow.classList.add('hidden');
        topBarSpecs.forEach(function(spec) {
            return spec.classList.add('hidden');
        });
        itemsToModify.forEach(function(item) {
            return item.classList.add('hidden');
        });
        headerNav.classList.add('hidden');
    // TABLET
    } else if (width < breakpointLaptop) {
        wirelessSpeakerMobile.classList.add('hidden');
        wirelessSpeakerTablet.classList.remove('hidden');
        menuButton.classList.add('hidden');
        designedForFutureMobile.classList.add('hidden');
        designedForFutureTablet.classList.remove('hidden');
        lunaEyeMobile.classList.add('hidden');
        lunaEyeTablet.classList.remove('hidden');
        featuresMobile.classList.add('hidden');
        featuresTablet.classList.remove('hidden');
        featuresLaptop.classList.add('hidden');
        footerLogo.classList.remove('hidden');
        footerArrow.classList.remove('hidden');
        topBarSpecs.forEach(function(spec) {
            return spec.classList.remove('hidden');
        });
        itemsToModify.forEach(function(item) {
            return item.classList.remove('hidden');
        });
        headerNav.classList.add('hidden');
    // LAPTOP
    } else {
        wirelessSpeakerMobile.classList.add('hidden');
        wirelessSpeakerTablet.classList.remove('hidden');
        menuButton.classList.add('hidden');
        designedForFutureMobile.classList.add('hidden');
        designedForFutureTablet.classList.remove('hidden');
        lunaEyeMobile.classList.add('hidden');
        lunaEyeTablet.classList.remove('hidden');
        featuresMobile.classList.add('hidden');
        featuresTablet.classList.add('hidden');
        featuresLaptop.classList.remove('hidden');
        topBarSpecs.forEach(function(spec) {
            return spec.classList.remove('hidden');
        });
        itemsToModify.forEach(function(item) {
            return item.classList.remove('hidden');
        });
        headerNav.classList.remove('hidden');
    }
}
window.addEventListener('load', handleResponsiveLayout);
window.addEventListener('resize', handleResponsiveLayout);
// slider mobile
var featuresArrowLeft = document.querySelector('.features__slider-arrow-left');
var featuresArrowRight = document.querySelector('.features__slider-arrow-right');
var featuresNumberChange = document.querySelector('.features__slider-number-change');
var featuresInfos = document.querySelectorAll('.features__info');
featuresArrowRight.addEventListener('click', function() {
    var number = Number(featuresNumberChange.textContent);
    if (number === featuresInfos.length) return;
    number++;
    featuresNumberChange.textContent = "0".concat(number);
    featuresInfos.forEach(function(featuresInfo, index) {
        featuresInfo.classList.toggle('hidden', index !== number - 1);
    });
});
featuresArrowLeft.addEventListener('click', function() {
    var number = Number(featuresNumberChange.textContent);
    if (number === 1) return;
    number--;
    featuresNumberChange.textContent = "0".concat(number);
    featuresInfos.forEach(function(featuresInfo, index) {
        featuresInfo.classList.toggle('hidden', index !== number - 1);
    });
});
// slider tablet
var featuresArrowLeftTablet = document.querySelector('.features-tablet__slider-arrow-left');
var featuresArrowRightTablet = document.querySelector('.features-tablet__slider-arrow-right');
var featuresNumberChangeTablet = document.querySelector('.features-tablet__slider-number-change');
var featuresInfosTablet = document.querySelectorAll('.features-tablet__info');
featuresArrowRightTablet.addEventListener('click', function() {
    var number = Number(featuresNumberChangeTablet.textContent);
    if (number === featuresInfosTablet.length) return;
    number++;
    featuresNumberChangeTablet.textContent = "0".concat(number);
    featuresInfosTablet.forEach(function(featuresInfo, index) {
        featuresInfo.classList.toggle('hidden', index !== number - 1);
    });
});
featuresArrowLeftTablet.addEventListener('click', function() {
    var number = Number(featuresNumberChangeTablet.textContent);
    if (number === 1) return;
    number--;
    featuresNumberChangeTablet.textContent = "0".concat(number);
    featuresInfosTablet.forEach(function(featuresInfo, index) {
        featuresInfo.classList.toggle('hidden', index !== number - 1);
    });
});

//# sourceMappingURL=Kickstarter.6174511c.js.map
